function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "nz_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h600v300H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "nz_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0l300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
})), /*#__PURE__*/React.createElement("g", {
  id: "nz_svg__b"
}, /*#__PURE__*/React.createElement("g", {
  id: "nz_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v.5L1 0z",
  transform: "translate(0 -.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-.5L1 0z",
  transform: "rotate(-36 .5 -.2)"
})), /*#__PURE__*/React.createElement("use", {
  transform: "scale(-1 1)",
  xlinkHref: "#nz_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(72 0 0)",
  xlinkHref: "#nz_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(-72 0 0)",
  xlinkHref: "#nz_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  transform: "scale(-1 1) rotate(72)",
  xlinkHref: "#nz_svg__a"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00247d",
  fillRule: "evenodd",
  d: "M0 0h640v480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-93 36.1) scale(.66825)"
}, /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  transform: "matrix(45.4 0 0 45.4 900 120)",
  xlinkHref: "#nz_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#cc142b",
  transform: "matrix(30 0 0 30 900 120)",
  xlinkHref: "#nz_svg__b"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(82 534.2 125) scale(.66825)"
}, /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  transform: "rotate(-82 519 -457.7) scale(40.4)",
  xlinkHref: "#nz_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#cc142b",
  transform: "rotate(-82 519 -457.7) scale(25)",
  xlinkHref: "#nz_svg__b"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(82 534.2 125) scale(.66825)"
}, /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  transform: "rotate(-82 668.6 -327.7) scale(45.4)",
  xlinkHref: "#nz_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#cc142b",
  transform: "rotate(-82 668.6 -327.7) scale(30)",
  xlinkHref: "#nz_svg__b"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-93 36.1) scale(.66825)"
}, /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  transform: "matrix(50.4 0 0 50.4 900 480)",
  xlinkHref: "#nz_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#cc142b",
  transform: "matrix(35 0 0 35 900 480)",
  xlinkHref: "#nz_svg__b"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 60,
  d: "M0 0l600 300M0 300L600 0",
  clipPath: "url(#nz_svg__c)",
  transform: "scale(.60681 .73139)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#cc142b",
  strokeWidth: 40,
  d: "M0 0l600 300M0 300L600 0",
  clipPath: "url(#nz_svg__d)",
  transform: "scale(.60681 .73139)"
});

var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.7 0v79.4H0V140h151.7v79.4h60.7v-79.3H364V79.4H212.4V0z",
    clipPath: "url(#nz_svg__c)",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M163.8 0v91.5H0v36.4h163.8v91.5h36.4V128h163.9V91.5H200.2V0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
};

export default SvgNz;